import './InsureResult.less';
import adBanner from './components/adBanner';
export { default as insureResultChannel } from './components/channel';
export { default as insureResultSuccess } from './components/success';
export { default as insureResultFail } from './components/fail';
export { default as insureResultDescription } from './components/description';
export { default as insureResultText } from './components/text';
export { default as insureResultBtn } from './components/btn';
export { default as insureOrderInfo } from './components/orderInfo';
export { adBanner };
export { default as InsureResult } from './InsureResult.js';
export { default } from './InsureResult.js';